module.exports = __webpack_public_path__ + "img/ic-triangle.157f6cc5.svg";